import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { DocumentsService } from '../documents.service';


@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css'],
  providers: [ DocumentsService ]
})


export class DocumentsComponent implements OnInit {
	title = 'Dokumenter';
	docCategories = [];
	selectedDoc: {};
	action: string;
	// action;
	//error: any;
	//urlSub = {};
	constructor(
		private documentsService: DocumentsService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private location: Location) { 
	}
	getDocCategories() {
		this.documentsService
			.getDocCategories()
			.subscribe( docCats => this.docCategories = docCats );
			// .catch( error => this.error = error ); // catch may not work?
    }
    getDoc(id: number) {
    	this.documentsService
    		.getDoc(id)
    		.subscribe( doc => this.selectedDoc = doc );
    }
    ngOnInit() {
		this.getDocCategories();

		// if id param is set in url, preselect document with corresponding id
		// var IDParam = this.router.rawUrlTree.queryParams.id;
		var IDParam: number;
		this.activatedRoute.queryParams.subscribe( (params: {}) => IDParam = parseInt( params['id'] ) );

		if ( IDParam != undefined && !isNaN(IDParam) ) {
			this.getDoc( IDParam );
		}

    	this.onPopState( IDParam );

    	// get action (if any)
		this.activatedRoute.params
							.subscribe(params => {
								console.log( typeof params['action'] );
								this.action = params['action'];
								console.log(this.action);
							});
							
	}
	/*
	 * ensure popState functionality (i.e. browser back/forward buttons).
	 * it almost works without, but this ensures it works 100%.
	 */
	onPopState( IDParam: number ) {
		/* 
		 * this would be the angular 2-way of doing it, but
		 * this makes the function fire the same amount of times as the current total of popState events (on each popState),
		 * (which is unwanted, we want it to fire only once pr popState)...
		 */
		// this.platformLocation.onPopState( () => {
			// if ( IDParam == undefined || isNaN(IDParam) ) {
				// delete this.selectedDoc;
			// }
    	// } );
    	/*
    	 * ...so we do it the regular js-way instead
    	 */
    	var mythis = this;
		window.onpopstate = function(event) {
    		if ( IDParam == undefined || isNaN(IDParam) ) {
				delete mythis.selectedDoc;
			}
    	}
	}
	selectDoc(doc: {}) {
		this.selectedDoc = doc;
		this.location.go( 'documents/', 'id=' + this.selectedDoc['id'] );
	};
	goToDocDetail() {
		this.router.navigate( ['document/', this.selectedDoc['id']] );
	}
	goToVg() { // just an example method to demonstrate how to link to external sites/pages. call it on an angular element like this: (click)="goToVg()"
		//window.location.href='http://vg.no'; // open in same tab
		var win = window.open('http://vg.no', '_blank'); // open in new tab
  		// win.focus(); // probably not necessary
	}
	goBack() {
		this.location.back();
	}
}









/* --- OPENPGP TESTING --- */
/*
// load openpgp
var openpgp = require('donna/backend/web/node_modules/openpgp/dist/openpgp.min.js'); // use as CommonJS, AMD, ES6 module or via window.openpgp
openpgp.initWorker({ path:'donna/backend/web/node_modules/openpgp/dist/openpgp.worker.min.js' }); // set the relative web worker path
openpgp.config.aead_protect = true; // activate fast AES-GCM mode (not yet OpenPGP standard)

// generate new key pair. this works but takes a seriously long time (15-20 secs)
var options = {
    userIds: [{ name:'Jon Smith', email:'jon@example.com' }], // multiple user IDs
    numBits: 4096,                                            // RSA key size
    passphrase: 'super long and hard to guess secret'         // protects the private key
};
openpgp.generateKey(options).then(function(key) {
    var privkey = key.privateKeyArmored; // '-----BEGIN PGP PRIVATE KEY BLOCK ... '
    var pubkey = key.publicKeyArmored;   // '-----BEGIN PGP PUBLIC KEY BLOCK ... '
    // console.log( privkey );
    // console.log( pubkey );
});
*/
/* --- END OPENPGP TESTING --- */


// WEBPACK FOOTER //
// ./src/app/documents/documents.component.ts